import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/**
 * 애니메이션 라이브러리 진입점. 플러그인 등록은 **여기 한 곳에서만** 해요 —
 * 컴포넌트마다 `registerPlugin` 을 부르면 등록 순서가 파일 임포트 순서에 끌려다녀요.
 *
 * GSAP 코드는 전부 `useGSAP()` 안에서 돌려요. 훅이 스코프 안의 트윈·ScrollTrigger 를
 * 언마운트 때 되돌려주기 때문에, 라우트를 오가도 죽은 노드에 트윈이 남지 않아요.
 * `prefers-reduced-motion` 은 `gsap.matchMedia()` 로 갈라요 — 컴포넌트가 언마운트되면
 * 미디어쿼리 리스너까지 같이 정리돼요.
 */
gsap.registerPlugin(useGSAP, ScrollTrigger, Flip);

/** 동작 줄이기가 꺼진 사용자에게만 애니메이션을 걸 때 쓰는 쿼리. */
export const MOTION_OK = "(prefers-reduced-motion: no-preference)";

export { Flip, gsap, ScrollTrigger, useGSAP };
